export default "__VITE_ASSET__p2sAevI3__"